import { render, staticRenderFns } from "./MorakhasiComponent.vue?vue&type=template&id=18a68534&"
import script from "./MorakhasiComponent.vue?vue&type=script&lang=js&"
export * from "./MorakhasiComponent.vue?vue&type=script&lang=js&"
import style0 from "./MorakhasiComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports